import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';

export const InfoCallout = ({ children }) => {
    return (
        <div
            className={cn([
                'tw-flex tw-items-start tw-gap-[12px] tw-p-[16px] tw-font-[500] tw-rounded-[8px]',
                'tw-text-black tw-bg-[#D5EDFB] tw-border tw-border-[#0091EA]'
            ])}
        >
            <img src='/assets/images/info-circle-blue.svg' title='criminal record checked' alt='check-circle' />
            {children}
        </div>
    );
};

InfoCallout.propTypes = {
    children: PropTypes.node.isRequired
};
